import { h, mount } from '../lib/dom';
import { api } from '../lib/api';

/**
 * Renders a <select> populated from GET /categories.
 *
 * Pattern: this component owns its async state. It renders a placeholder,
 * fetches, then re-renders. Callers register an onChange handler to react.
 */
export async function renderCategoryFilter(
  target: HTMLSelectElement,
  options: { selected?: string; onChange: (value: string) => void },
) {
  // Placeholder while loading
  mount(target, h('option', { value: '' }, 'Loading…'));

  try {
    const { data } = await api.categories.list();
    target.replaceChildren(
      h('option', { value: '' }, 'All categories'),
      ...data.map((c) =>
        h(
          'option',
          { value: c.category, selected: c.category === options.selected ? 'selected' : null },
          `${c.category} (${c.count})`,
        ),
      ),
    );
  } catch {
    target.replaceChildren(h('option', { value: '' }, 'Failed to load'));
  }

  target.addEventListener('change', () => options.onChange(target.value));
}
